<div class="service-account-panel" *ngIf="isServiceAccount">
  <div class="service-account-header">Poller Credentials</div>
  <div class="service-account-body">
    <div class="service-account-status">
      <span class="status-dot" [class.status-ok]="credentialsSavedOnServer" [class.status-missing]="!credentialsSavedOnServer"></span>
      <span *ngIf="credentialsSavedOnServer">Credentials saved — cron poller can log in as this account.</span>
      <span *ngIf="!credentialsSavedOnServer">No credentials saved server-side. Cron poller cannot run yet.</span>
    </div>
    <button class="sync-creds-btn" type="button" (click)="syncServiceCredentials()" [disabled]="credentialSyncLoading">
      {{ credentialSyncLoading ? 'Syncing…' : (credentialsSavedOnServer ? 'Re-sync credentials' : 'Sync credentials') }}
    </button>
    <div *ngIf="credentialSyncMessage" class="sync-creds-msg">{{ credentialSyncMessage }}</div>
    <div *ngIf="credentialSyncError" class="sync-creds-err">{{ credentialSyncError }}</div>
  </div>
</div>

<div class="boost-panel" *ngIf="enableBoostUi">
  <div class="boost-panel-header">Boost & Redeem</div>
  <div class="boost-panel-body">
    <div class="boost-gauge-area">
      <div class="boost-target-line" *ngIf="boostTarget?.targetType === 'ship'">
        <pss-sprite *ngIf="boostTargetSpriteId" class="boost-target-sprite" [spriteId]="boostTargetSpriteId" [alt]="boostTargetName()"></pss-sprite>
        <div class="boost-target-name">{{ boostTargetName() }}</div>
      </div>

      <div class="boost-btn-wrapper">
        <button class="boost-btn boost-btn-disabled" type="button" aria-disabled="true" (click)="triggerUseBoost()">
          <span class="boost-btn-progress" [style.width.%]="boostGaugeProgress() * 100"></span>
          <span class="boost-btn-text">
            Use Boost
            <span class="boost-btn-meta">
              {{ (boostGaugeProgress() * 100) | number:'1.0-0' }}% • {{ formatHhMmSs(displaySeconds) }}
            </span>
          </span>
        </button>
      </div>

      <div class="boost-note" *ngIf="boostGauge && displaySeconds <= 0">No boost available yet.</div>
      <div class="boost-note" *ngIf="boostGauge && displaySeconds > 0 && displaySeconds < 300">Boost is available; less than 5:00 remaining.</div>
      <div class="boost-note" *ngIf="!boostGauge">Boost gauge not found; research boost action is still available if a target is selected.</div>
    </div>

    <div class="redeem-control">
      <button class="redeem-open-btn" (click)="showRedeemModal = true">Redeem Code</button>
    </div>
  </div>

  <div class="redeem-modal-overlay" *ngIf="showRedeemModal" (click)="showRedeemModal = false">
    <div class="redeem-modal" (click)="$event.stopPropagation()">
      <div class="redeem-modal-header">
        <span>Redeem Code</span>
        <button class="modal-close" (click)="showRedeemModal = false">✕</button>
      </div>

      <div class="redeem-modal-body">
        <label for="redeem-code-input">Code</label>
        <input id="redeem-code-input" [(ngModel)]="redeemInput" placeholder="Enter code here" maxlength="32" />

        <div *ngIf="redeemCodes.length > 0" class="redeem-row">
          <label for="redeem-code-select">Saved codes</label>
          <select id="redeem-code-select" [(ngModel)]="selectedRedeemCode" (change)="onRedeemCodeSelect(selectedRedeemCode)">
            <option *ngFor="let code of redeemCodes" [value]="code.code">{{ code.code }} ({{ code.status }})</option>
          </select>
        </div>

        <button class="boost-btn" [disabled]="redeemLoading" (click)="redeem()">Redeem</button>
        <div class="redeem-message" [ngClass]="{ error: redeemMessage.toLowerCase().includes('failed') || redeemMessage.toLowerCase().includes('expired') }">
          {{ redeemMessage }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="section-toggle" (click)="showResources = !showResources">
  <span>Resources</span>
  <span class="toggle-arrow">{{ showResources ? '&#9650;' : '&#9660;' }}</span>
</div>
<div *ngIf="showResources" class="section-body">
  <div class="stat-row">
    <div class="stat-cell">
      <div class="stat-icon mineral">⬡</div>
      <div class="stat-info">
        <div class="stat-val">{{ formatNumber(details.minerals) }}</div>
        <div class="stat-key">Minerals</div>
      </div>
    </div>
    <div class="stat-cell">
      <div class="stat-icon gas">◈</div>
      <div class="stat-info">
        <div class="stat-val">{{ formatNumber(details.gas) }}</div>
        <div class="stat-key">Gas</div>
      </div>
    </div>
    <div class="stat-cell">
      <div class="stat-icon bux">$</div>
      <div class="stat-info">
        <div class="stat-val">{{ formatNumber(details.bux ?? details.starbux) }}</div>
        <div class="stat-key">Bux</div>
      </div>
    </div>
    <div class="stat-cell">
      <div class="stat-icon doves">🕊️</div>
      <div class="stat-info">
        <div class="stat-val">{{ formatNumber(details.doves ?? '—') }}</div>
        <div class="stat-key">Doves</div>
      </div>
    </div>
  </div>
</div>

<div class="section-toggle" (click)="showPvp = !showPvp">
  <span>PVP Record</span>
  <span class="toggle-arrow">{{ showPvp ? '&#9650;' : '&#9660;' }}</span>
</div>
<div *ngIf="showPvp" class="section-body">
  <div class="pvp-grid">
    <div class="pvp-cell">
      <div class="pvp-label">Attack Wins</div>
      <div class="pvp-val win">{{ formatNumber(details.pvpAttackWins) }}</div>
    </div>
    <div class="pvp-cell">
      <div class="pvp-label">Attack Losses</div>
      <div class="pvp-val loss">{{ formatNumber(details.pvpAttackLosses) }}</div>
    </div>
    <div class="pvp-cell">
      <div class="pvp-label">Defence Wins</div>
      <div class="pvp-val win">{{ formatNumber(details.pvpDefenceWins) }}</div>
    </div>
    <div class="pvp-cell">
      <div class="pvp-label">Defence Losses</div>
      <div class="pvp-val loss">{{ formatNumber(details.pvpDefenceLosses) }}</div>
    </div>
    <div class="pvp-cell span2">
      <div class="pvp-label">Attack Win Rate</div>
      <div class="pvp-val accent">{{ winRate(details.pvpAttackWins, details.pvpAttackLosses) }}</div>
    </div>
    <div class="pvp-cell span2">
      <div class="pvp-label">Defence Win Rate</div>
      <div class="pvp-val accent">{{ winRate(details.pvpDefenceWins, details.pvpDefenceLosses) }}</div>
    </div>
  </div>
</div>
